module.exports = __webpack_public_path__ + "media/images/step_circle-a2ec49eb519a9d47c4e896325257de19.png";